function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollectingResults = function SvgCollectingResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 1.333 1.333"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.333v1.333H0z",
    style: {
      fill: "#fabc3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.665.216a.3.3 0 0 0-.217.09L.47.328a.276.276 0 0 1 .39 0L.88.306a.3.3 0 0 0-.216-.09m0 .117a.17.17 0 0 0-.124.054L.565.41a.136.136 0 0 1 .2 0L.789.385A.17.17 0 0 0 .665.333m0 .107a.034.034 0 1 0 0 .069.034.034 0 0 0 0-.069",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.384.566H.95q.024.002.026.026v.377A.026.026 0 0 1 .95.995H.384A.026.026 0 0 1 .358.97V.592C.358.577.37.566.384.566",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.394.585h.545Q.952.586.952.6v.334A.013.013 0 0 1 .94.946H.394A.013.013 0 0 1 .381.933V.599Q.382.586.394.585",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.265.951h.803q.008 0 .009.01v.006c0 .023-.039.044-.112.044H.367c-.074 0-.11-.025-.11-.044V.96Q.258.952.265.951",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.622.951h.09v.01h-.09z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.394.585A.013.013 0 0 0 .381.6V.91L.649.585z",
    style: {
      fill: "#4d4d4d"
    }
  }));
};
export default SvgCollectingResults;